import {
	DOC_APPROVED,
	DOC_APPROVING,
	DOC_APPROVING_FAILED,
	DOC_APPROVING_INITIALIZE,
} from "../actions/types";
const initialState = {
	isApproving: false,
	isApproved: false,
	isFailed: false,
	id: "",
};
export default function (state = initialState, action) {
	switch (action.type) {
		case DOC_APPROVING:
			return {
				...state,
				isApproving: true,
				isApproved: false,
				isFailed: false,
				id: "",
			};
		case DOC_APPROVED:
			return {
				...state,
				isApproving: false,
				isApproved: true,
				isFailed: false,
				id: action.payload,
			};
		case DOC_APPROVING_INITIALIZE:
			return {
				...state,
				isApproving: false,
				isApproved: false,
				isFailed: false,
				id: null,
			};

		case DOC_APPROVING_FAILED:
			return {
				...state,
				isApproving: false,
				isApproved: false,
				isFailed: true,
				id: "",
			};

		default:
			return state;
	}
}
